var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNetzwerktechnik = function SvgNetzwerktechnik(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58325 1.66669H15.4166V8.58335H8.58325V1.66669ZM10.5833 3.66669V6.58335H13.4166V3.66669H10.5833Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32129 16.429H8.15462V23.3456H1.32129V16.429ZM3.32129 18.429V21.3456H6.15462V18.429H3.32129Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6666 16.429H15.8333V23.3456H22.6666V16.429ZM17.8333 21.3456V18.429H20.6666V21.3456H17.8333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5H20.25V14.9584H18.25V13.5H5.75V14.9584H3.75V11.5H11V10.0417H13V11.5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNetzwerktechnik);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjU4MzI1IDEuNjY2NjlIMTUuNDE2NlY4LjU4MzM1SDguNTgzMjVWMS42NjY2OVpNMTAuNTgzMyAzLjY2NjY5VjYuNTgzMzVIMTMuNDE2NlYzLjY2NjY5SDEwLjU4MzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjMyMTI5IDE2LjQyOUg4LjE1NDYyVjIzLjM0NTZIMS4zMjEyOVYxNi40MjlaTTMuMzIxMjkgMTguNDI5VjIxLjM0NTZINi4xNTQ2MlYxOC40MjlIMy4zMjEyOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjY2NjYgMTYuNDI5SDE1LjgzMzNWMjMuMzQ1NkgyMi42NjY2VjE2LjQyOVpNMTcuODMzMyAyMS4zNDU2VjE4LjQyOUgyMC42NjY2VjIxLjM0NTZIMTcuODMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMTMgMTEuNUgyMC4yNVYxNC45NTg0SDE4LjI1VjEzLjVINS43NVYxNC45NTg0SDMuNzVWMTEuNUgxMVYxMC4wNDE3SDEzVjExLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";